<template>
  <div id="change-test-paper">
    <!-- 替换试题界面 -->
    <div class="line">
      <div class="title">科目:</div>
      <div class="value">
        <el-select
          v-model="data.subject"
          placeholder="请选择要替换的科目"
          multiple
          clearable
          filterable
        >
          <el-option
            v-for="it in option"
            :key="it.id"
            :label="it.name"
            :value="it.id"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="line">
      <div class="title">题干:</div>
      <div class="value">
        <el-input
          v-model="data.stem"
          placeholder="请输入题干"
          clearable
        ></el-input>
      </div>
    </div>
    <div class="line">
      <el-table :data="list" border style="width: 100%" height="500">
        <el-table-column prop="stemTxt" label="题干"> </el-table-column>

        <el-table-column fixed="right" label="替换" width="100">
          <template slot-scope="scope">
            <el-button
              type="success"
              @click="handleClick(scope.row.id)"
              size="small"
              plain
              >选择</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import * as paperData from "../../views/admin/question_bank/js/question.js";
export default {
  name: "diy_dialog_paper",
  props: {
    paperData: {
      type: Object,
      default: function () {
        return {
          subject: [],
          topicnType: "0",
          stem: "",
          type: "0",
        };
      },
    },
  },
  data() {
    return {
      data: this.paperData,
      list: [],
      option: [],
    };
  },
  watch: {
    paperData() {
      this.data = this.paperData;
    },
    data(newValue) {
      this.$emit("showPaper", this.data);
    },
  },
  methods: {
    /**
     * 获取所有科目
     */
    async getAllSubjectForSelect() {
      try {
        let resultData = await this.$request({
          url: "/subjects/getAllSubjectForSelect",
          method: "post",
          data: null,
        });
        this.option = resultData;
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 获取考试下拉框
     */
    async getAllQuestionBankListForSelect() {
      try {
        let resultData = await this.$request({
          url: "/questionBank/getAllQuestionBankListForSelect",
          method: "post",
          data: {
            subject: this.data.subject,
            topicnType: this.data.topicnType,
            type: "0", // 考试题库
            stem: this.data.stem,
          },
        });
        this.list = resultData;
      } catch (error) {}
    },
    handleClick(id) {
      this.$emit("handleClickChangePaper", id);
    },
  },
  async mounted() {
    await this.getAllSubjectForSelect();
    await this.getAllQuestionBankListForSelect();
  },
};
</script>

<style lang="less" scoped>
#change-test-paper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  // background-color: #333;
  > .line {
    width: 100%;
    height: auto;
    display: flex;
    > .title {
      width: 20%;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      font-size: 16px;
      font-weight: bold;
      margin-right: 10px;
    }
    > .value {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
      border-bottom: 1px solid #e9e9e9;
      box-sizing: border-box;
      margin-bottom: 20px;
      > .title {
        width: 100%;
        height: auto;
        line-height: 30px;
        display: flex;
        align-items: center;
        text-align: left;
        > .nd {
          margin-left: 10px;
          font-size: 14px;

          .el-icon-star-off {
            font-size: 15px;
            color: #e9e9e9;
          }
          .el-icon-star-on {
            color: #ffe710;
            font-size: 17px;
          }
        }
        /deep/ p {
          display: inline;
        }
      }
      > .xx {
        width: 100%;
        height: auto;
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        box-sizing: border-box;
        > .itel {
          width: 100%;
          height: auto;
          line-height: 30px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          margin-bottom: 5px;
          font-size: 15px;
        }
      }
      > .op {
        width: 100%;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-bottom: 10px;
        > .va {
          width: 80px;
          margin-right: 10px;
          display: flex;
          font-size: 15px;
          align-items: center;
          > span {
            margin-left: 5px;
          }
        }
        > .but {
          width: auto;
          padding: 0 5px;
          box-sizing: border-box;
          font-size: 14px;
          color: #2187fc;
          transition: 0.3s;
          cursor: pointer;
          &:hover {
            text-decoration: underline;
            text-underline-offset: 5px;
          }
        }
      }
    }
  }
}
</style>